import React, { useEffect, useContext } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import { Col, Row } from 'react-bootstrap';
import Navmenu from './NavMenu';
import Footer from './Footer';
import { HeaderProvider } from '../contexts/HeaderContext';
import Header from './Header';
import { AuthContext, AuthConsumer } from '../lib/contexts/AuthContext';
import Messages from "../lib/components/Messages";

export default function Layout(props) {
  const navigate = useNavigate();
  const authContext = useContext(AuthContext);

  useEffect(() => {
    if (authContext && !authContext.isAuthenticated()) {
      navigate('/login')
    }
  }, [authContext, navigate])

  return (
    <AuthConsumer>
      {context => (
        <HeaderProvider>
          <div className="content">
            <Navmenu />
            <Header />
              <Row>
                <Col sm={12}>
                  <Messages />
                </Col>
              </Row>
              <Row>
              <Col sm={12}>
                {props.children}
              </Col>
              </Row>
          </div>
          <Footer />
        </HeaderProvider>
      )}
    </AuthConsumer>
  )
}

export const LayoutRoute = ({ component: Component, ...rest  }) => { 
  return (
    <Routes>
      <Route {...rest} element = {
        <Layout> 
          <Component />
        </Layout>
      } />
    </Routes>
  )
}
